import React, { useState } from 'react';
import axios from 'axios';
import { Mail, MapPin, Send, Headphones, Clock, Shield } from 'lucide-react';
import config from '../config';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await axios.post(`${config.API_BASE_URL}/contact.php`, formData);
      setStatus({
        type: 'success',
        message: 'Thank you for contacting us! We will get back to you soon.'
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Failed to submit form. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">Get In Touch</div>
            <h1 className="page-title">Connect With Our Team</h1>
            <p className="page-subtitle">
              Ready to transform your IT operations? Let's discuss how we can help your business thrive
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <div className="info-header">
                <h2>Let's Start a Conversation</h2>
                <p>
                  We're here to help you transform your IT operations. Reach out to us 
                  and let's discuss how we can support your business goals.
                </p>
              </div>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">
                    <Mail size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Email Us</h4>
                    <p>info@kevitco.com</p>
                    <span className="method-description">Get a response within 24 hours</span>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Visit Us</h4>
                    <p>India</p>
                    <span className="method-description">Global operations with local presence</span>
                  </div>
                </div>
              </div>

              <div className="support-features">
                <h3>Why Choose Us</h3>
                <div className="features-grid">
                  <div className="feature-item">
                    <Headphones size={20} />
                    <span>24x7 Global Support</span>
                  </div>
                  <div className="feature-item">
                    <Clock size={20} />
                    <span>Fast Response Time</span>
                  </div>
                  <div className="feature-item">
                    <Shield size={20} />
                    <span>Secure Communication</span>
                  </div>
                </div>
              </div>

              <div className="support-badge">
                <h4>Follow-the-Sun Model</h4>
                <p>Our global teams ensure round-the-clock support with seamless handoffs across time zones</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
